<template>
  <div class="home-page">
    <section class="hero-section">
      <div class="hero-bg" aria-hidden="true">
        <div class="hero-bg-gradient" />
        <div class="hero-bg-pattern" />
        <div class="hero-blob hero-blob--1" />
        <div class="hero-blob hero-blob--2" />
        <div class="hero-blob hero-blob--3" />
      </div>
      <div class="container hero-layout">
        <div class="hero-copy">
          <div class="hero-eyebrow">
            <span class="hero-eyebrow-dot" />
            Android APK · 2026 guide
          </div>
          <h1>GB WhatsApp Download APK - Latest Updated Version 2026</h1>
          <p class="hero-tagline">
Stable builds · Anti-ban aware · Privacy &amp; themes
</p>
          <p class="hero-subtitle">
            Get the enhanced WhatsApp experience millions use for customization, privacy controls, and richer media—explained
            clearly, without hype.
          </p>
          <div class="hero-actions">
            <router-link to="/download/" class="btn-primary btn-large hero-cta-primary">
              Download GBWhatsApp APK
            </router-link>
            <router-link to="/features/" class="btn-secondary btn-large hero-cta-secondary">
              Explore features
            </router-link>
          </div>
          <p class="version-info">
Version: 18.80 | Size: 82 MB | Android 4.4+
</p>
          <div class="hero-trust-strip" role="note">
            <strong>Smart download habit:</strong>
            match file size and version on GBWaps, avoid random mirrors, scan if unsure, and back up before every update—similar
            discipline to what serious sites like
            <!-- <a href="https://gbwhatsp.com/" rel="noopener noreferrer nofollow" target="_blank">gbwhatsp.com</a> -->
            remind readers, but with our own checklist (we do not guarantee third-party APKs).
          </div>
        </div>
        <div class="hero-visual" aria-hidden="true">
          <div class="hero-visual-card hero-visual-card--back" />
          <div class="hero-phone-wrap">
            <div class="hero-phone-shadow" />
            <div class="hero-phone">
              <div class="hero-phone-bar" />
              <div class="hero-phone-screen">
                <div class="hero-phone-status">
                  <span>9:41</span>
                  <span class="hero-phone-signal">●●●●</span>
                </div>
                <div class="hero-phone-appbar">
                  <span class="hero-phone-avatar">GB</span>
                  <div>
                    <div class="hero-phone-title">
GB WhatsApp
</div>
                    <div class="hero-phone-sub">
v18.80 · online
</div>
                  </div>
                </div>
                <div class="hero-phone-chat">
                  <div class="hero-bubble hero-bubble--in">
                    <span class="hero-bubble-label">Tip</span>
                    Back up chats before updating the APK.
                  </div>
                  <div class="hero-bubble hero-bubble--out">
                    Themes &amp; privacy toggles ready.
                  </div>
                  <div class="hero-bubble hero-bubble--in hero-bubble--short">
                    Tap Download to get the file.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hero-float-pill hero-float-pill--1">
82 MB
</div>
          <div class="hero-float-pill hero-float-pill--2">
v18.80
</div>
          <div class="hero-float-pill hero-float-pill--3">
            <span class="hero-android-icon" aria-hidden="true">🤖</span>
            4.4+
          </div>
        </div>
      </div>
    </section>

    <div class="home-body">
      <div class="home-layout container">
        <aside class="home-sidebar">
          <HomeToc :items="homeToc" />
        </aside>

        <div class="home-main content-narrow">
          <!-- Band A -->
          <section class="home-band">
            <p class="intro-lead">
              <template v-for="(part, j) in introLead.parts">
                <router-link v-if="part.link" :key="'intro-l-' + j" :to="part.link.to">
{{ part.link.text }}
</router-link>
                <span v-else :key="'intro-t-' + j">{{ part.text }}</span>
              </template>
            </p>

            <h2 class="h2-tight">
New at a Glance
</h2>
            <div class="feature-pills-enhanced">
              <div v-for="pill in featurePills" :key="pill.label" class="feature-pill-enhanced">
                <div class="feature-pill-icon">
{{ getFeatureIcon(pill.label) }}
</div>
                <div class="feature-pill-content">
                  <span class="feature-pill-title">{{ pill.label }}</span>
                  <span class="feature-pill-hint">{{ pill.hint }}</span>
                </div>
              </div>
            </div>

            <div class="spotlight-grid">
              <article v-for="block in spotlightBlocks" :key="block.title" class="spotlight-card card">
                <h3>{{ block.title }}</h3>
                <p>{{ block.text }}</p>
              </article>
            </div>
          </section>

          <!-- Band: Download showcase -->
          <section class="home-band home-band--alt">
            <DownloadShowcase :data="downloadShowcase" />
          </section>

          <!-- Band: Verify -->
          <section class="home-band">
            <h2 class="h2-tight">
Before You Install
</h2>
            <div class="verify-grid">
              <article v-for="card in verifyBlocks" :key="card.title" class="verify-card card">
                <div class="verify-card-head">
                  <span class="verify-card-icon" aria-hidden="true">{{ card.icon }}</span>
                  <h3>{{ card.title }}</h3>
                </div>
                <ul>
                  <li v-for="(line, i) in card.items" :key="i">
{{ line }}
</li>
                </ul>
              </article>
            </div>
            <ul class="checklist checklist--compact">
              <li v-for="(line, i) in preDownloadChecks" :key="i">
{{ line }}
</li>
            </ul>
          </section>

          <!-- Band: Quick FAQ + App info -->
          <section class="home-band home-band--alt">
            <h2 class="h2-tight">
Quick Answers
</h2>
            <div class="quick-faq-enhanced">
              <div v-for="(item, index) in faqSnippets" :key="item.q" class="quick-faq-item-enhanced">
                <div class="quick-faq-icon">
{{ getFaqIcon(index) }}
</div>
                <div class="quick-faq-content">
                  <h3 class="quick-faq-q">
{{ item.q }}
</h3>
                  <p class="quick-faq-a">
{{ item.a }}
</p>
                </div>
              </div>
            </div>

            <div class="app-info-panel card">
              <div class="app-info-panel-visual">
                <img
                  :src="homeImages.siteLogo"
                  alt="GB WhatsApp logo"
                  width="120"
                  height="120"
                  loading="lazy"
                  class="app-info-panel-img">
              </div>
              <table class="app-info-table">
                <tbody>
                  <tr v-for="row in appInfo" :key="row.label">
                    <td>{{ row.label }}</td>
                    <td>{{ row.value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="warning-box">
              <strong>Disclaimer:</strong>
              GBWaps is not affiliated with WhatsApp or Meta Platforms, Inc. This is an independent informational website.
            </div>
          </section>

          <!-- PDF 15× H2 长文 -->
          <section
            v-for="section in homeSections"
            :id="section.id"
            :key="section.id"
            class="home-band site-section"
            :class="{ 'home-band--alt': section.altBand }">
            <div v-if="section.layout !== 'what-is-intro'" class="section-header">
              <h2>{{ section.h2 }}</h2>
              <span v-if="section.badge" class="section-badge">{{ section.badge }}</span>
            </div>

            <WhatIsIntro
              v-if="section.layout === 'what-is-intro'"
              :intro-parts="section.introParts"
              :banner-src="section.figureSrc"
              :banner-alt="section.figure ? section.figure.alt : ''"
              :blocks="section.blocks" />

            <template v-else>
              <figure v-if="section.figureSrc" class="media-figure card">
                <img
                  :src="section.figureSrc"
                  :alt="section.figure.alt"
                  width="768"
                  height="403"
                  loading="lazy"
                  class="media-figure-img">
                <figcaption v-if="section.figure.caption">
{{ section.figure.caption }}
</figcaption>
              </figure>

              <ContentBlocks :blocks="section.blocks" />
            </template>

            <div v-if="section.layout === 'requirement-cards'" class="requirement-cards-grid">
              <article
                v-for="card in downloadRequirementCards"
                :key="card.title"
                class="requirement-card card">
                <div class="requirement-card-visual">
                  <img
                    v-if="card.image"
                    :src="card.image"
                    :alt="card.imageAlt"
                    loading="lazy"
                    class="requirement-card-img">
                  <span v-else class="requirement-card-icon" aria-hidden="true">{{ card.icon }}</span>
                </div>
                <div class="requirement-card-body">
                  <h3 class="requirement-card-title">
                    <span class="requirement-card-icon-inline" aria-hidden="true">{{ card.icon }}</span>
                    {{ card.title }}
                  </h3>
                  <ul class="requirement-card-list">
                    <li v-for="(line, i) in card.items" :key="i">
{{ line }}
</li>
                  </ul>
                  <router-link v-if="card.link" :to="card.link.to" class="requirement-card-link">
                    {{ card.link.text }}
                  </router-link>
                </div>
              </article>
            </div>

            <div v-if="section.layout === 'feature-grid'" class="feature-grid feature-grid--with-img">
              <article
                v-for="card in featureCards"
                :key="card.title"
                class="feature-card feature-card--media feature-card--full-image">
                <img
                  :src="card.image"
                  :alt="card.imageAlt"
                  loading="lazy"
                  width="800"
                  height="600"
                  class="feature-card-img">
              </article>
            </div>

            <div v-if="section.layout === 'install-steps'" class="step-media-grid">
              <article v-for="step in installSteps" :key="step.step" class="step-media-card card">
                <span class="step-media-num">{{ step.step }}</span>
                <img :src="step.image" :alt="step.alt" loading="lazy" class="step-media-img">
                <h3>{{ step.title }}</h3>
                <p>{{ step.text }}</p>
              </article>
            </div>

            <ul v-if="section.layout === 'checklist'" class="checklist">
              <li v-for="(line, i) in preDownloadChecks" :key="'req-' + i">
{{ line }}
</li>
            </ul>

            <table v-if="section.layout === 'comparison'" class="comparison-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>WhatsApp</th>
                  <th>GBWhatsApp</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in comparisonRows" :key="row.feature">
                  <td>{{ row.feature }}</td>
                  <td>{{ row.official }}</td>
                  <td>{{ row.gb }}</td>
                </tr>
              </tbody>
            </table>

            <FaqAccordion v-if="section.layout === 'faq'" :items="faqItems" />
          </section>

          <!-- Pros / Cons -->
          <section class="home-band home-band--alt site-section">
            <h2>GB WhatsApp Pros and Cons</h2>
            <div class="pros-cons-grid">
              <div class="card pros-box">
                <h3>Pros</h3>
                <ul>
                  <li v-for="(item, i) in prosList" :key="'p-' + i">
{{ item }}
</li>
                </ul>
              </div>
              <div class="card cons-box">
                <h3>Cons</h3>
                <ul>
                  <li v-for="(item, i) in consList" :key="'c-' + i">
{{ item }}
</li>
                </ul>
              </div>
            </div>
          </section>

          <div class="warning-box">
            <strong>Reminder:</strong>
            GBWaps is an independent guide. We do not host WhatsApp servers or guarantee any mod build. Download responsibly and
            back up chats before every update. You can also compare related
            <a href="https://gbdwnpro.org/">GBWhatsApp APK</a>
            version notes before choosing a build.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/gbwaps/home.css';
import FaqAccordion from '@/components/gbwaps/FaqAccordion.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import DownloadShowcase from '@/components/gbwaps/DownloadShowcase.vue';
import HomeToc from '@/components/gbwaps/HomeToc.vue';
import WhatIsIntro from '@/components/gbwaps/WhatIsIntro.vue';
import { initGbwapsPageUI } from '@/utils/gbwaps-ui';
import {
	APP_INFO,
	FEATURE_PILLS,
	SPOTLIGHT_BLOCKS,
	PRE_DOWNLOAD_CHECKS,
	PROS_LIST,
	CONS_LIST,
	FEATURE_CARDS,
	COMPARISON_ROWS,
	HOME_FAQ_SNIPPETS,
	HOME_FAQ,
} from '@/data/home-content';
import { HOME_SECTIONS, INTRO_LEAD } from '@/data/home-sections';
import {
	HOME_IMAGES,
	DOWNLOAD_SHOWCASE,
	INSTALL_STEPS,
	VERIFY_BLOCKS,
	HOME_TOC,
	DOWNLOAD_REQUIREMENT_CARDS,
} from '@/data/home-images';

export default {
	name: 'Home',
	components: { FaqAccordion, ContentBlocks, DownloadShowcase, HomeToc, WhatIsIntro },
	data() {
		const homeSections = HOME_SECTIONS.map((section, index) => {
			const figure = section.figure;
			let figureSrc = null;
			if (figure && figure.srcKey) {
				figureSrc = HOME_IMAGES[figure.srcKey];
			}
			return {
				...section,
				altBand: index % 2 === 1,
				figureSrc,
				introParts: section.introParts || [],
			};
		});

		return {
			introLead: INTRO_LEAD,
			homeToc: HOME_TOC,
			homeSections,
			homeImages: HOME_IMAGES,
			downloadShowcase: DOWNLOAD_SHOWCASE,
			installSteps: INSTALL_STEPS,
			verifyBlocks: VERIFY_BLOCKS,
			downloadRequirementCards: DOWNLOAD_REQUIREMENT_CARDS,
			appInfo: APP_INFO,
			featurePills: FEATURE_PILLS,
			spotlightBlocks: SPOTLIGHT_BLOCKS,
			preDownloadChecks: PRE_DOWNLOAD_CHECKS,
			prosList: PROS_LIST,
			consList: CONS_LIST,
			featureCards: FEATURE_CARDS,
			comparisonRows: COMPARISON_ROWS,
			faqSnippets: HOME_FAQ_SNIPPETS,
			faqItems: HOME_FAQ,
		};
	},
	mounted() {
		this.$nextTick(() => initGbwapsPageUI(this.$el));
	},
	updated() {
		this.$nextTick(() => initGbwapsPageUI(this.$el));
	},
	methods: {
		getFeatureIcon(label) {
			const iconMap = {
				'Auto Reply': '\uD83D\uDCAC',
				'Hide Online Status': '\uD83D\uDC41\uFE0F',
				'Status Download': '\uD83D\uDCE5',
				'DND / Airplane Mode': '\u2708\uFE0F',
				'Media Sharing': '\uD83D\uDCCE',
			};
			return iconMap[label] || '\u2728';
		},
		getFaqIcon(index) {
			const icons = [
				'\u2753',
				'\uD83D\uDD0D',
				'\uD83D\uDCF1',
				'\uD83D\uDD04',
				'\uD83C\uDFAF',
				'\uD83D\uDCA1',
				'\uD83D\uDEE1\uFE0F',
				'\uD83D\uDE80',
			];
			return icons[index % icons.length];
		},
	},
};
</script>
